import React, { useEffect, useState } from "react";
import axios from "./common/axios";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SignIn from "./login/login";
import ResetPW from "./login/resetpw";
import ConfirmPW from "./login/pwconfirm";
import NewPW from "./login/newpw";
import SignUp from "./login/signup";
import SsoPopup from "./login/SsoPopup";
import ProtectedRoute from "./common/privateRoute";
import LoaList from "./pages/loa/List";
import ApprovalList from "./pages/approval/List";
import LoaDetailForm from "./pages/loa/DetailForm";
import { approvalMenuList } from "./lib/menuList";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        {/* 로그인 라우터 */}
        <Route path="/login" element={<SignIn />} />
        <Route path="/reset-password" element={<ResetPW />} />
        <Route path="/password-confirmation" element={<ConfirmPW />} />
        <Route path="/new-password" element={<NewPW />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/sso-popup" element={<SsoPopup />} />
        {approvalMenuList.map((c, i) => {
          const { label, path, bpName } = c;

          return (
            <Route key={i} path={path} element={<ProtectedRoute />}>
              <Route
                index
                element={<LoaList bpName={bpName} title={label} />}
              />
              <Route
                path="detail"
                element={<LoaDetailForm bpName={bpName} title={label} />}
              />
            </Route>
          );
        })}

        <Route path="/approval/contract" element={<ProtectedRoute />}>
          <Route
            index
            element={<ApprovalList bpName="contract" title="기성 지급" />}
          />
        </Route>
        <Route path="/approval/changeOrder" element={<ProtectedRoute />}>
          <Route
            index
            element={<ApprovalList bpName="contract" title="선급금 지급" />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;

const RootRedirect = () => {
  const [to, setTo] = useState(null);

  useEffect(() => {
    axios.post("/loa_is_logged_in")
      .then((res) => setTo(res.data.isLoggedIn ? "/loa/all" : "/login"))
      .catch(() => setTo("/login"));
  }, []);

  if (!to) return null;
  return <Navigate to={to} replace />;
};
